import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets the window scroll position to the top on every route navigation.
 * The window is the app's scroll container (cf. `BackToTopButton`), so pages
 * would otherwise render at the previous route's scroll offset. Keyed on
 * pathname only — search-param changes within a page keep their position.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
